import React, { useEffect, useState } from "react";
import { Card, CardBody, Row, Col, FormControl } from "react-bootstrap";
import axiosInstance from "../../../services/axios.instance";
import { API_URL } from "../../../services/apiConfig";
import "./style.css";

interface DriverOtp {
  phone_number: string;
  otp: string;
  msg_time: string;
  otp_expiry: string;
}

const VendorDriverOtp: React.FC = () => {
  const [phoneNumber, setPhoneNumber] = useState<string>("");
  const [driverOtps, setDriverOtps] = useState<DriverOtp[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  // -------------------------
  // GET API CALL
  // -------------------------
  const getAllDriversOtps = async (phone?: string) => {
    try {
      setLoading(true);

      const url = `${API_URL.GET_DRIVER_OTPS}${
        phone ? `?phoneNumber=${phone}` : ""
      }`;

      const response = await axiosInstance.get(url);

      const formattedData = (response.data || []).map((otp: any) => ({
        phone_number: otp.phone_number,
        otp: otp.otp,
        msg_time: otp.msg_time ? new Date(otp.msg_time).toLocaleString() : "-",
        otp_expiry: otp.otp_expiry
          ? new Date(otp.otp_expiry).toLocaleString()
          : "-",
      }));

      setDriverOtps(formattedData);
    } catch (error) {
      console.error("Error fetching driver OTPs", error);
      setDriverOtps([]);
    } finally {
      setLoading(false);
    }
  };

  // -------------------------
  // SEARCH HANDLER
  // -------------------------
  const handlePhoneSearch = (value: string) => {
    setPhoneNumber(value);
    getAllDriversOtps(value);
  };

  // -------------------------
  // ON LOAD
  // -------------------------
  useEffect(() => {
    getAllDriversOtps();
  }, []);

  return (
    <div className="row">
      <Card className="card-bg-afl text-start">
        <CardBody>
          {/* Search */}
          <Row className="justify-content-end mb-3">
            <Col md="4">
              <FormControl
                placeholder="Search by phone number"
                value={phoneNumber}
                onChange={(e) => handlePhoneSearch(e.target.value)}
              />
            </Col>
          </Row>

          {/* Table */}
          <div className="dashboard-table-div-vendor">
            <table className="table table-hover dashboard-table-vendor">
              <thead>
                <tr>
                  <th>Phone Number</th>
                  <th>OTP</th>
                  <th>Message Time</th>
                  <th>OTP Expiry</th>
                </tr>
              </thead>
              <tbody>
                {loading && (
                  <tr>
                    <td colSpan={4}>Loading...</td>
                  </tr>
                )}

                {!loading && driverOtps.length === 0 && (
                  <tr>
                    <td colSpan={4}>No OTP records found</td>
                  </tr>
                )}

                {!loading &&
                  driverOtps.map((otp, index) => (
                    <tr key={index}>
                      <td>{otp.phone_number}</td>
                      <td>{otp.otp}</td>
                      <td>{otp.msg_time}</td>
                      <td>{otp.otp_expiry}</td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </CardBody>
      </Card>
    </div>
  );
};

export default VendorDriverOtp;
